import { render, staticRenderFns } from "./Drs.vue?vue&type=template&id=203c28dd&"
import script from "./Drs.vue?vue&type=script&lang=js&"
export * from "./Drs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports